"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilliSecond = exports.Year = exports.Week = exports.Day = exports.Hour = exports.Minute = void 0;
var uom_1 = require("uom");
exports.Minute = uom_1.UnitFormat.createUnitFormat("min", 2);
exports.Hour = uom_1.UnitFormat.createUnitFormat("h", 2);
exports.Day = uom_1.UnitFormat.createUnitFormat("days", 0);
exports.Week = uom_1.UnitFormat.createUnitFormat("weeks", 0);
exports.Year = uom_1.UnitFormat.createUnitFormat("year", 0);
exports.MilliSecond = uom_1.UnitFormat.createUnitFormat("ms", 0);
//# sourceMappingURL=duration-format.js.map